import { WorkflowStep } from "./types";

/**
 * Ścieżka akceptacji wniosku o zaangażowanie z Magistratu — wiersze
 * `ItemAcceptationSequence` dla typu BudgetEngagementRequest (57AD20DF-…):
 * Lp, Label → nazwa etapu, AcceptDescription → formuła etapu (tekst dekretu wpisywany
 * do dokumentu wniosku przy akceptacji; przy odrzuceniu BE wpisuje „Odrzucono”).
 * Osoby (UserIds) trzeba przypisać w builderze — w Magistracie były to konta
 * burmistrza i zastępców, wydziału budżetu i skarbnika.
 */
export const MAGISTRAT_ENGAGEMENT_STEPS: WorkflowStep[] = [
  {
    id: "mag-1",
    order: 1,
    name: "Akceptacja burmistrza",
    description:
      "Akceptacja kierownika jednostki (w Magistracie: burmistrz i zastępcy — kto pierwszy, ten decyduje).",
    documentFormula:
      "Zobowiązania wynikające z wnioskowanego wydatku mieszczą się w planie finansowym jednostki lub WPF",
    role: "MANAGER",
    actions: ["approve", "reject", "send_back"],
    conditions: [],
    approvalMode: "any",
    assignees: [],
  },
  {
    id: "mag-2",
    order: 2,
    name: "Ocena zgodności z planem",
    description:
      "Wydział budżetu: sprawdzenie, czy planowany wydatek mieści się w planie finansowym / WPF.",
    documentFormula:
      "Potwierdzam, iż planowany wydatek jest zgodny z planem finansowym jednostki lub WPF",
    role: "FINANCE",
    actions: ["approve", "reject", "send_back"],
    conditions: [],
    approvalMode: "any",
    assignees: [],
  },
  {
    id: "mag-3",
    order: 3,
    name: "Akceptacja księgowa",
    description:
      "Skarbnik / główny księgowy — etap kończący ścieżkę (IsEndingSequence): po nim zaangażowanie jest zaakceptowane.",
    documentFormula:
      "Zobowiązania wynikające z wnioskowanego wydatku mieszczą się w planie finansowym jednostki lub WPF",
    role: "ACCOUNTANT",
    actions: ["approve", "reject", "send_back"],
    conditions: [],
    approvalMode: "any",
    assignees: [],
  },
];
